import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('argyle_account', {
  user_id: '',
  argyle_flow_id: '',
  argyle_user_id: '',
  user_token: '',
  connections: [],
})
